/**
 * Панель ростера HR, 30px (03.10, владелец): «24 · 2 в отпуске», фильтр по роли
 * (Dropdown M.4, purple по A2), «?» со справкой вместо повторяющихся подсказок
 * (DESIGN-CONTEXT 01.08) и «+ Нанять». Пока открыт шит найма, «+ Нанять» скрыт —
 * «Отмена» на экране одна (канон 03.08).
 */
import { useState } from "react";
import { Dropdown, actionPairCss as ap } from "../../components/shared";
import { STAFF_ROLES, STAFF_ROLE_LABELS, type StaffRoleId } from "@ub/shared/staffRoles";
import { TipBox } from "../eo/PriceRow";
import pcss from "../eo/prices.module.css";
import css from "./roster.module.css";

export type RoleFilter = StaffRoleId | "all";

interface Props {
  /** null — список ещё не загружен (счётчик не показываем, чтобы не мигал «0»). */
  total: number | null;
  /** Всего работающих, без фильтра — мета пункта «Все роли». */
  all: number;
  vacation: number;
  filter: RoleFilter;
  counts: Partial<Record<StaffRoleId, number>>;
  onFilter: (f: RoleFilter) => void;
  canHire: boolean;
  hireOpen: boolean;
  onHire: () => void;
  mode: "oo" | "eo";
}

const Caret = () => (
  <svg width="9" height="9" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.6" aria-hidden="true"><path d="M5 9l7 7 7-7" /></svg>
);
const Plus = () => (
  <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" aria-hidden="true"><path d="M12 5v14M5 12h14" /></svg>
);

export function RosterToolbar(p: Props) {
  const [dd, setDd] = useState<HTMLElement | null>(null);
  const [tip, setTip] = useState<HTMLElement | null>(null);
  const items = [
    { id: "all", label: "Все роли", meta: String(p.all) },
    ...STAFF_ROLES.filter((r) => (p.counts[r] ?? 0) > 0).map((r) => ({ id: r, label: STAFF_ROLE_LABELS[r], meta: String(p.counts[r]) })),
  ];
  return (
    <div className={css.bar}>
      <span className={css.count}>
        {p.total === null ? null : <><b>{p.total}</b>{p.vacation ? <> · {p.vacation} в отпуске</> : null}</>}
      </span>
      <button type="button" className={`${css.filter} ${p.filter !== "all" ? css.filterOn : ""}`} onClick={(e) => setDd(e.currentTarget)}>
        {p.filter === "all" ? "Все роли" : STAFF_ROLE_LABELS[p.filter]}<Caret />
      </button>
      <button type="button" className={pcss.qmark} data-qmark="" aria-label="Справка" onClick={(e) => { const a = e.currentTarget; setTip((t) => (t ? null : a)); }}>
        <span>?</span>
      </button>
      {p.canHire && !p.hireOpen ? (
        <button type="button" className={`${ap.abtn} ${ap.cf} ${ap.solo} ${css.hire}`} onClick={p.onHire}>
          <Plus />Нанять
        </button>
      ) : null}
      <Dropdown open={!!dd} anchor={dd} multi={false} title="Роль" items={items} selectedIds={[p.filter]}
        onCommit={(ids) => { const id = String(ids[0] ?? "all"); p.onFilter(id === "all" ? "all" : (id as StaffRoleId)); }}
        onClose={() => setDd(null)} />
      {tip ? (
        <TipBox anchor={tip} onClose={() => setTip(null)}>
          <p><b>Тап по строке</b> — телефон, Telegram, статус «работает / отпуск»{p.mode === "eo" ? ", роли" : ""} и «Уволить».</p>
          <p><b>«нет TG»</b> — вход не привязан. «Ссылка» даёт одноразовую ссылку в бота на 72 часа: человек открывает её в Telegram и сразу входит в кабинет.</p>
          <p><b>Уволить</b> — вход закрывается сразу, неначатая работа снимается сама: игры, админ зала, дежурства ДК, МК, допработы. Список снятых игр покажем — расстановку нужно пересобрать.</p>
          <p><b>Уволенные</b> — внизу списка; «Вернуть» открывает вход заново.</p>
          {p.mode === "oo" ? <p>ОО нанимает и увольняет операторов; ДК, ОО и EO — только EO.</p> : <p>Основная роль — старшая из отмеченных.</p>}
        </TipBox>
      ) : null}
    </div>
  );
}
